import EntityTable from "@mirage/components/entityTable/EntityTable";
import { Stack, TablePaginationBaseProps } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import PlanningApplicationsService from "@publicPortal/services/PlanningApplicationsService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { Filter, FilterItem } from "@shared/mirage/entityTable/Filter";
import "../PlanningApplication.css";
import { memo, useCallback, useMemo } from "react";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

interface PAConstraintsTabContentProps {
    paId?: number;
    service: PlanningApplicationsService;
}

const PAConstraintsTabContent = memo((props: PAConstraintsTabContentProps) => {
    const { isMobile } = useDeviceDetect();
    const onGeneralConstraintsPageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            return await props.service.generalConstraintsPageRequest(pageRequest);
        },
        [props.service]
    );

    const onPlanningConstraintsPageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            return await props.service.planningConstraintsPageRequest(pageRequest);
        },
        [props.service]
    );

    const getFilter = () => {
        const filter = { parts: [] } as Filter;
        const filterItems: FilterItem[] = [];
        filterItems.push({ columnName: "paId", operator: "=", value: props.paId || -1 });
        filter.parts.push({ filterItems: filterItems });

        return filter;
    };

    const columns: GridColDef[] = useMemo(() => {
        return [
            { field: "name", headerName: "Name", flex: 0.4 },
            { field: "fieldValue", headerName: "Value", flex: 1 },
        ];
    }, []);
    const overridePaginationProps = useCallback((baseProps: TablePaginationBaseProps) => ({ ...baseProps, showFirstButton: false, showLastButton: false }), []);

    return (
        <Stack gap={2}>
            <EntityTable
                title="General Constraints"
                key="general-constraints-entityTable"
                stateKey="general-constraints-entityTable"
                onPageRequest={onGeneralConstraintsPageRequest}
                columns={columns}
                filter={getFilter()}
                rowHeight={30}
                columnHeaderHeight={40}
                noRecordsImage={false}
                toolbarOptions={{ disableFilter: true }}
                hideRowsPerPage={isMobile}
                overridePaginationProps={overridePaginationProps}
            />
            <EntityTable
                title=" Planning Policy Constraints"
                key="planning-constraints-entityTable"
                stateKey="planning-constraints-entityTable"
                onPageRequest={onPlanningConstraintsPageRequest}
                columns={columns}
                filter={getFilter()}
                rowHeight={30}
                columnHeaderHeight={40}
                noRecordsImage={false}
                toolbarOptions={{ disableFilter: true }}
                hideRowsPerPage={isMobile}
                overridePaginationProps={overridePaginationProps}
            />
        </Stack>
    );
});

export default PAConstraintsTabContent;
